export const projects = [
  {
    title: "互动网页艺术：生之葬礼",
    description:
      "一个基于网页的互动延展作品，作为实体艺术装置的延伸，借助人工智能，引发人们对生命、死亡与自我反思等主题的深入思考。\n",
    features: [
      "Reflective narrative guided by participant inputs",
      "Customized AI-generated eulogy",
      "ChatGPT & ElevenLabs API integration",
    ],
    tech: [
      "React",
      "Next.js",
      "JavaScript",
      "GPT-4 API",
      "Text-to-Speech API",
      "Vercel",
      "Backblaze B2",
    ],
    links: {
      demo: "https://www.thelivingfuneral.art/",
      github: "https://github.com/jasonli2004/TheLivingFuneral",
    },
  },
  {
    title: "AI来猜画",
    description: "一款结合创意绘画与 AI 识别的趣味涂鸦游戏(安卓)。",
    features: [
      "Interactive canvas for drawing",
      "AI-powered recognition",
      "Multiple difficulty levels",
    ],
    tech: ["Jetpack Compose", "Kotlin", "Vision AI"],
    links: {
      demo: "https://appetize.io/embed/b_ll3l6aehmudirl7dv7kyda2jii",
      github: "https://github.com/jasonli2004/GuessTheSketch",
    },
  },
  /*ChatGPT (GPT-4 Vision/Completion Models), ElevenLabs Text-to-Speech API, React, Next.js, Vercel, Backblaze B2.*/
  {
    title: "AI讲义学习卡片生成器（开发中）",
    description:
      "一个借助LLM将课堂笔记或幻灯片转化为简洁记忆卡片的网页应用，助力高效学习。",
    features: [
      "Upload lecture materials (images or PDFs)",
      "AI-powered summarization",
      "Streamlined workflow",
    ],
    tech: ["JavaScript", "Svelte", "Firebase", "GenAI"],
    links: {
      demo: "https://www.youtube.com/watch?v=5oBghd_5bHM",
      github: "https://github.com/jasonli2004/FlashCardGPT",
    },
  },
  {
    title: "饮食指南网站",
    description:
      "一个根据用户偏好提供营养信息与点餐建议的网站，帮助用户按自己的饮食计划做出更健康的选择。",
    features: [
      "Upload lecture materials (images or PDFs)",
      "AI-powered summarization",
      "Streamlined workflow",
    ],
    tech: ["Flask", "PostgreSQL", "HTML"],
    links: {
      github:
        "https://github.com/jasonli2004/UndergradProjects/tree/main/Chick-fil-A_diet_guide_website",
    },
  },
  {
    title: "个人作品集网站",
    description: "这是你现在正在浏览的作品集网站—由我独立设计与开发。",
    features: [
      "Upload lecture materials (images or PDFs)",
      "AI-powered summarization",
      "Streamlined workflow",
    ],
    tech: ["React", "JavaScript", "Vercel"],
    links: {
      github: "https://github.com/jasonli2004/portfolio",
    },
  },
];
